import style from './home-safety-solution.module.scss';
import { HomeSafetySolutionState, IFeaturesSafety } from './home-safety-solution.state';
import AccordionSection from './sections/accordion-section/accordion-section';
import FeaturesSection from './sections/features-section/feature-section';
import PreviewSection from './sections/preview-section/preview-section';
import ProblemSection from './sections/problem-section/problem-section';
import ProjectInfoSection from './sections/project-info-section/project-info-section';
import ResultsSection from './sections/results-section/results-section';
import TechnologiesSection from './sections/technologies-section/technologies-section';
import Breadcrumbs from '@components/shared/miscellaneous/breadcrumbs/breadcrumbs';

interface HomeSafetySolutionComponentProjectProps {
  breadcrumbsText: string;
}

const HomeSafetySolutionComponent = ({ breadcrumbsText }: HomeSafetySolutionComponentProjectProps) => {
  const {
    previewSection,
    projectInfoSection,
    problemSection,
    accordionSection,
    technologySection,
    resultsSection,
    featuresSection,
  } = HomeSafetySolutionState;
  return (
    <>
      <Breadcrumbs lastElementTitle={breadcrumbsText} />
      <div className={`${style.bnb__project}`}>
        <PreviewSection
          title={previewSection.title}
          subtitle={previewSection.subtitle}
          text={previewSection.text}
          image={previewSection.image}
        />
        <hr />
        <ProjectInfoSection title={projectInfoSection.title} list={projectInfoSection.list} />
        <hr />
        <ProblemSection title={problemSection.title} text={problemSection.text} />
        <hr />
        <AccordionSection
          title={accordionSection.title}
          subtitle={accordionSection.subtitle}
          accordion={accordionSection.accordion}
        />
        <hr />
        <TechnologiesSection title={technologySection.title} images={technologySection.images} />
        <hr />
        <ResultsSection title={resultsSection.title} items={resultsSection.items} />
        {featuresSection.features.map((feature: IFeaturesSafety, index: number) => {
          return (
            <FeaturesSection
              key={index}
              image={feature.image}
              title={feature.title}
              text={feature.text}
              reversed={index % 2 !== 0}
            />
          );
        })}
      </div>
    </>
  );
};

export default HomeSafetySolutionComponent;
